const FAUCET_API_BASE = process.env.REACT_APP_API_BASE_URL || ''
export type PostCheckinResponse = {
  data?: unknown
  success?: boolean
  [key: string]: unknown
}

const joinUrl = (base: string, path: string) => {
  const normalizedBase = base.endsWith('/') ? base.slice(0, -1) : base
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  return `${normalizedBase}${normalizedPath}`
}

/**
 * POST faucetUrl – submit daily faucet. Body: { wallet, period }.
 */
export const postFaucet = async (wallet: string, faucetUrl: string): Promise<PostCheckinResponse> => {
  if (!FAUCET_API_BASE) {
    throw new Error('Faucet API is not configured.')
  }

  const url = joinUrl(FAUCET_API_BASE, faucetUrl)
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ wallet }),
  })

  if (!response.ok) {
    const res = await response.json()
    throw new Error(`${res?.error?.message}`)
  }

  return (await response.json()) as PostCheckinResponse
}
